import 'polyfill-object.fromentries'

import { ResizeObserver } from '@juggle/resize-observer'
import flat from 'array.prototype.flat'
import flatMap from 'array.prototype.flatmap'
import * as bufferModule from 'buffer'
import process from 'process'

flat.shim()
flatMap.shim()

// @ts-ignore
const Buffer = bufferModule.Buffer ?? bufferModule.default.Buffer

declare global {
  interface Window {
    Buffer: typeof Buffer
    process: typeof process
  }
}

if (!window.process) {
  window.process = process
}

if (!window.Buffer) {
  window.Buffer = Buffer
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver
}
